import { INSTALLMENT_LIST, UPDATE_INSTALLMENT_PLAN, ADD_INSTALLMENT_TO_AGREEMENT, ADD_ALERT, DELETE_INSTALLMENT, CREATE_INSTALLMENT_SCHEDULE } from 'src/actions/types';
import sleektrading from '../apis/sleektrading';
import shortId from "shortid";

export const installmentsList = () => dispatch => {
  sleektrading.get('installments')
    .then(response => {
      dispatch({
        type: INSTALLMENT_LIST,
        payload: response.data.data.installements
      });
    });
}

export const installmentsCreate = (values) => (dispatch) => {
  sleektrading.post('installments', values).then((response) => {
    dispatch({
      type: ADD_INSTALLMENT_TO_AGREEMENT,
      payload: response.data.data.installment
    });
    dispatch({
      type: ADD_ALERT,
      payload: {
          key: shortId.generate(),
          status: 'success',
          color:'info',
          message: response.data.message,
          errors: {}
      }
  });
  });
};

export const deleteInstallment= (installment_id) => async dispatch => {
  sleektrading.delete(`/installments/${installment_id}`)
  .then(response => {
      if(response.data.code == 201) {
          dispatch({
              type:DELETE_INSTALLMENT, 
              payload:installment_id
          });
          dispatch({
              type: ADD_ALERT,
              payload: {
                  key: shortId.generate(),
                  status: 'success',
                  color:'info',
                  message: response.data.message,
                  errors: {}
              }
          });
      } else {
          dispatch({
              type: ADD_ALERT,
              payload: {
                  key: shortId.generate(),
                  status: 'success',
                  color:'info',
                  message: response.data.message,
                  errors: {}
              }
          });
      }
  }).catch(error => {
      dispatch({
          type:ADD_ALERT,
          payload:{
          key:shortId.generate(),
          status:'error',
          message:error.response.data.message,
          errors:error.response.data.errors
      }
  });
  });
}

// export const printInstallment = (params) => dispatch => {
//   const config = { responseType: 'blob', Accept: 'application/json' };
//   sleektrading.post('/installments/print', params, config)
//     .then(responce => {
//       const url = window.URL.createObjectURL(new Blob([responce.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       const date = new Date().getTime()+'installmentplan.pdf';
//       link.setAttribute('download', date);
//       document.body.appendChild(link);
//       link.click();
//       const blob = new Blob([responce.data], 
//         {
//           type:"application/pdf",
//         });
//     });
// }
export const printInstallment = (params) => dispatch => {
  const config = { responseType: 'blob', Accept:'application/pdf' };   
  sleektrading.post('plan/print', params, config)
  .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const date = new Date().getTime()+'installmentplan.pdf';
      link.setAttribute('download', date);
      document.body.appendChild(link);
      link.click();
      const blob = new Blob([response.data], {
          type: "application/pdf",
      });
  });
}

export const installmentsUpdate = (values) => (dispatch) => {
  sleektrading.post('installment_payments', values).then((response) => {
    dispatch({
      type: UPDATE_INSTALLMENT_PLAN,
      payload: response.data.data.installment
    });
    dispatch({
      type: ADD_ALERT,
      payload: {
          key: shortId.generate(),
          status: 'success',
          color:'info',
          message: response.data.message,
          errors: {}
      }
    });
  });
};

export const scheduleUpdate = (values) => (dispatch) => {
  sleektrading.post('/installment_schedules/update',values).then((response) => {
    console.log(response.data)
  });
};

export const installmentReceived = () => (dispatch) => {
    dispatch({
      type: ADD_ALERT,
      payload: {
          key: shortId.generate(),
          status: 'success',
          color:'info',
          message: "Installment already received for this month",
          errors: {}
      }
  });
};

